import React from "react"
import LandingButton from "./LandingButton"
import LandingReveal from "./LandingReveal"
import LandingSectionHeader from "./LandingSectionHeader"
import { PRAYER_REQUEST_HASH, TESTIMONY_HASH } from "../../lib/prayerTestimony"

const scriptureClassName =
  "font-dm-sans text-xs italic leading-6 tracking-wide text-[#4a4a4a] sm:text-sm sm:leading-7"

const scriptureRefClassName = "font-dm-sans text-xs tracking-wide text-[#9e7e43] sm:text-sm"

const titleClassName = "font-outfit text-lg font-semibold tracking-tight text-dc-primary-900 sm:text-2xl"

const bodyClassName = "font-dm-sans text-sm leading-6 text-[#5a5a5a] sm:text-base sm:leading-7"

const buttonClassName = "mt-auto w-full px-3 py-2.5 text-sm sm:text-base"

const cardClassName =
  "flex h-full w-full flex-col gap-3 rounded-xl border p-4 shadow-[0_6px_24px_-10px_rgba(0,43,122,0.08)] backdrop-blur-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_-12px_rgba(0,43,122,0.12)] sm:gap-3.5 sm:p-5"

const LandingPrayerTestimonySection: React.FC = () => {
  return (
    <section id="prayers-and-testimonies" className="relative scroll-mt-24 overflow-hidden bg-white py-20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_0%_50%,rgba(158,126,67,0.06),transparent_50%)]" />

      <div className="relative mx-auto flex max-w-6xl flex-col items-center px-4 md:px-8 lg:px-20">
        <LandingSectionHeader
          eyebrow="We're praying with you"
          title="Prayers & Testimonies"
          description="Share your prayer requests or testimonies with us"
        />
      </div>

      <div className="relative mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-3 px-4 sm:max-w-4xl sm:gap-4 md:px-8 lg:px-20">
        <LandingReveal className="min-w-0">
          <article className={`${cardClassName} border-[#ebebeb] bg-[#fafafa]/80`}>
            <div className="flex flex-col gap-1.5">
              <h3 className={titleClassName}>
                Prayer Requests
              </h3>
              <p className={scriptureClassName}>
                &ldquo;For where two or three are gathered in my name, there am I among them.&rdquo;
              </p>
              <p className={scriptureRefClassName}>Matthew 18:20</p>
            </div>
            <p className={bodyClassName}>
              Our prayer team would love to stand with you in faith.
            </p>
            <LandingButton href={`#${PRAYER_REQUEST_HASH}`} className={buttonClassName}>
              Submit Request
            </LandingButton>
          </article>
        </LandingReveal>

        <LandingReveal delay={0.1} className="min-w-0">
          <article className={`${cardClassName} border-[#9e7e43]/25 bg-white`}>
            <div className="flex flex-col gap-1.5">
              <h3 className={titleClassName}>
                Share a Testimony
              </h3>
              <p className={scriptureClassName}>
                &ldquo;They overcame by the blood of the Lamb and the word of their testimony.&rdquo;
              </p>
              <p className={scriptureRefClassName}>Revelation 12:11</p>
            </div>
            <p className={bodyClassName}>
              Encourage others by sharing what God has done.
            </p>
            <LandingButton
              variant="outline-primary"
              href={`#${TESTIMONY_HASH}`}
              className={buttonClassName}
            >
              Share Story
            </LandingButton>
          </article>
        </LandingReveal>
      </div>

    </section>
  )
}

export default LandingPrayerTestimonySection
